"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MPShop
 * API documentation
 *
 * The version of the OpenAPI document: 0.0.1-alpha.58
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResponseGetOrderAddOnsToJSON = exports.ResponseGetOrderAddOnsFromJSONTyped = exports.ResponseGetOrderAddOnsFromJSON = exports.instanceOfResponseGetOrderAddOns = void 0;
var ProductType_1 = require("./ProductType");
var ResponseGetOrderAddOnsOrderAddOnsInner_1 = require("./ResponseGetOrderAddOnsOrderAddOnsInner");
/**
 * Check if a given object implements the ResponseGetOrderAddOns interface.
 */
function instanceOfResponseGetOrderAddOns(value) {
    var isInstance = true;
    isInstance = isInstance && "orderId" in value;
    isInstance = isInstance && "anchorProduct" in value;
    isInstance = isInstance && "orderAddOns" in value;
    return isInstance;
}
exports.instanceOfResponseGetOrderAddOns = instanceOfResponseGetOrderAddOns;
function ResponseGetOrderAddOnsFromJSON(json) {
    return ResponseGetOrderAddOnsFromJSONTyped(json, false);
}
exports.ResponseGetOrderAddOnsFromJSON = ResponseGetOrderAddOnsFromJSON;
function ResponseGetOrderAddOnsFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'orderId': json['orderId'],
        'anchorProduct': (0, ProductType_1.ProductTypeFromJSON)(json['anchorProduct']),
        'orderAddOns': (json['orderAddOns'].map(ResponseGetOrderAddOnsOrderAddOnsInner_1.ResponseGetOrderAddOnsOrderAddOnsInnerFromJSON)),
    };
}
exports.ResponseGetOrderAddOnsFromJSONTyped = ResponseGetOrderAddOnsFromJSONTyped;
function ResponseGetOrderAddOnsToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'orderId': value.orderId,
        'anchorProduct': (0, ProductType_1.ProductTypeToJSON)(value.anchorProduct),
        'orderAddOns': (value.orderAddOns.map(ResponseGetOrderAddOnsOrderAddOnsInner_1.ResponseGetOrderAddOnsOrderAddOnsInnerToJSON)),
    };
}
exports.ResponseGetOrderAddOnsToJSON = ResponseGetOrderAddOnsToJSON;
